import React from "react";
import Layout from "../Component/Layout/Layout";
import BannerSection from "../Component/BannerSection";
import ContactInfo from "../Component/Contact/ContactInfo";
import ContactMap from "../Component/Contact/ContactMap";

const Contact = () => {
  return (
    <Layout>
      <BannerSection
        heading="Contact Us"
        image="/images/contact_banner.jpg"
        description="Contact Us"
      />

      <section className="contact mt_100 xs_mt_70 mb_100 xs_mb_70">
        <div className="container">
          <ContactInfo />
          <ContactMap />
        </div>
      </section>
    </Layout>
  );
};

export default Contact;
